import styled from "styled-components";

const Wrapper = styled.ul`
  list-style: none;
  padding-left: 0;
`;

export default Wrapper;
